import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

export default function admissionsProcess() {
	const navigation       = document.querySelector('[data-name="admission-process-navigation"]');
	const content          = document.querySelector('[data-name="admission-process-content"]');
	const contentItems     = document.querySelectorAll('[data-name="admission-process-item"]');
	const contentLastItem  = contentItems[contentItems.length - 1];

	if ( navigation && content && contentItems.length > 0 && window.innerWidth > 767 ) {

		// Pin navigation
		ScrollTrigger.create({
            trigger: navigation,
			start: 'top top+=10px',
			end: `${content.offsetHeight} top+=${navigation.offsetHeight}`,
			pin: true,
			pinSpacing: false,
			//markers: true
        });

		// Detect which one is active
		contentItems.forEach((item, index) => {
			let itemNumber = item.getAttribute('data-value')
			let activeNavigationItem = navigation.querySelector('[data-value="' + itemNumber + '"]');

			gsap.to( item, {
				scrollTrigger: {
					trigger: item,
					start: 'top top+=220',
					end: 'bottom top+=180',
					//markers: true,
					//id: index,
					onEnter: () => {
						activeNavigationItem.classList.add('active');
					},
					onLeave: () => {
						activeNavigationItem.classList.remove('active');
					},
					onEnterBack: () => {
						activeNavigationItem.classList.add('active');
					},
					onLeaveBack: () => {
						activeNavigationItem.classList.remove('active');
					}
				}
			});
		});

	}
}